module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialogContent",
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.dialogContent.title != '' ? _vm.dialogContent.title : '提示',
      "size": "tiny",
      "visible": _vm.$store.state.Dialog.dialogName === _vm.dialogContent.dialogVisible,
      "top": _vm.top,
      "show-close": _vm.showClose,
      "close-on-click-modal": _vm.closeOnClickModal
    }
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.dialogContent.content,
      "type": "warning",
      "closable": false,
      "show-icon": _vm.showIcon
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogContent.btnShow == false ? false : true),
      expression: "dialogContent.btnShow == false? false: true"
    }],
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "2px"
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.dialogContent.confirm != '' ? _vm.dialogContent.confirm : '确认'))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-be9bd52c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/dialogContent.vue
// module id = 604
// module chunks = 64